import React from 'react';
import { StyledHtml } from '@postenbring/hedwig-react';

export const Wysiwyg = ({ text }) => {
    const markUp = {__html: text };

    return (
       <StyledHtml dangerouslySetInnerHTML={markUp}></StyledHtml>
    );
}